module.exports = __webpack_public_path__ + "static/media/google_app.95c931f3.png";